
<main class="page-main">
  <div class="layout layout--central layout--central-flush">
    <div class="layout__row">

      <div class="layout__sidecol">
        <nav class="central-mainnav" id="app-bar-desktop">
          <ul class="central-mainnav__list list-unstyled">
            <li [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
              @if (person?.broker_id > 0 || person?.console_access) {
                <a  href="javascript:void(0);" routerLink="/broker-dashboard">
                  <svg class="icon">
                    <use xlink:href="#dashboard-filled"></use>
                  </svg>
                  <span>Home</span>
                </a>
              }
            </li>
            <li>
              @if (person?.broker_id > 0 || person?.console_access) {
                <a  href="javascript:void(0);"  (click)="changeMode('Policies')">
                  <svg class="icon">
                    <use xlink:href="#policies-filled"></use>
                  </svg>
                  <span>Policies</span>
                </a>
              }
            </li>
            @if (person?.broker_id > 0 || person?.console_access) {
              <li>
                <a href="javascript:void(0);" (click)="changeMode('Quotes')">
                  <svg class="icon">
                    <use xlink:href="#quotes-filled"></use>
                  </svg>
                  <span>Quotes</span>
                </a>
              </li>
            }
            @if (claims) {
              <li >
                <a href="javascript:void(0);"  (click)="changeMode('Claims')">
                  <svg class="icon">
                    <use xlink:href="#claims-filled"></use>
                  </svg>
                  <span>Claims</span>
                </a>
              </li>
            }
            <!-- <li *ngIf="underwriting" >
            <a href="javascript:void(0);"  (click)="changeMode('Underwriting')">
              <svg class="icon">
                <use xlink:href="#claims-filled"></use>
              </svg>
              <span>Underwriting</span>
            </a>
          </li> -->
          <li [ngClass]="moreActiveDesktop ? 'is-active':null">
            <a href="javascript:;" (click)="activateMore('desktop')" id="sidesheet-appbar-more-trigger">
              <svg class="icon">
                <use xlink:href="#more-circle-filled"></use>
              </svg>
              <span>More</span>
            </a>
          </li>
        </ul>
      </nav>
      <div class="central-getassistance">
        <a href="everything.emergency-assist-select-emergency-full.html" class="central-getassistance__btn"><svg class="icon">
          <use xlink:href="#navigation-sos"></use>
        </svg></a>
      </div>
    </div>

    <nav class="app-bar" [ngClass]="moreActiveMobile ? 'more-active':null" id="app-bar">
      <ul>
        <li [routerLinkActive]="'is-active'"  [routerLinkActiveOptions]="{exact: true}">
          @if (person?.broker_id > 0 || person?.console_access) {
            <a href="javascript:void(0);"  href="javascript:void(0);" routerLink="/broker-dashboard">
              <svg class="icon">
                <use xlink:href="#dashboard-filled"></use>
              </svg>
              <span>Home</span>
            </a>
          }
        </li>
        <li>
          <a href="javascript:void(0);" (click)="changeMode('Policies')">
            <svg class="icon">
              <use xlink:href="#policies-filled"></use>
            </svg>
            <span>Policies</span>
          </a>
        </li>
        @if (person?.broker_id > 0 || person?.console_access) {
          <li >
            <a href="javascript:void(0);" (click)="changeMode('Quotes')">
              <svg class="icon">
                <use xlink:href="#quotes-filled"></use>
              </svg>
              <span>Quotes</span>
            </a>
          </li>
        }
        @if (claims) {
          <li>
            <a href="javascript:void(0);" (click)="changeMode('Claims')">
              <svg class="icon">
                <use xlink:href="#claims-filled"></use>
              </svg>
              <span>Claims</span>
            </a>
          </li>
        }
        <li [ngClass]="moreActiveMobile ? 'is-active':null">
          <a href="#app-bar-more" (click)="activateMore('mobile')" data-toggle="modal">
            <svg class="icon">
              <use xlink:href="#more-circle-filled"></use>
            </svg>
            <span>More</span>
          </a>
        </li>
      </ul>
    </nav>
    <div class="sidesheet-appbar" [ngClass]="moreActiveDesktop ? 'is-active':null" id="sidesheet-appbar-more">
      <div class="sidesheet-appbar__inner">

        <div class="sidesheet-appbar__body">

          <nav class="modal-appbar__menu">

            <div class="modal-appbar__menu-title"><small>Cover</small></div>
            <ul>
              @if (underwriting) {
                <li >
                  <a href="javascript:;" (click)="changeMode('Underwriting')">
                    <svg class="icon"><use xlink:href="#memberships"></use></svg>
                    <span>Underwriting</span>
                  </a>
                </li>
              }
            </ul>

            <!-- <div class="modal-appbar__menu-title"><small>Policies</small></div>
            <ul>
              <li>
                <a href="javascript:;" [routerLink]="['/' + RouterLinks.PolicyResources]">
                  <svg class="icon"><use xlink:href="#document"></use></svg>
                  <span>Documents</span>
                </a>
              </li>
              <li>
                <a href="javascript:;" [routerLink]="['/' + RouterLinks.PolicyInsuredItems]">
                  <svg class="icon"><use xlink:href="#inventory"></use></svg>
                  <span>Insured items</span>
                </a>
              </li>
              <li>
                <a href="javascript:;" [routerLink]="['/' + RouterLinks.PolicyAddons]">
                  <svg class="icon"><use xlink:href="#policy-benefits"></use></svg>
                  <span>Benefits</span>
                </a>
              </li>
              <li>
                <a href="javascript:;" [routerLink]="['/' + RouterLinks.Account]">
                  <svg class="icon"><use xlink:href="#profile"></use></svg>
                  <span>Profile</span>
                </a>
              </li>
            </ul> -->

            <div class="modal-appbar__menu-title"><small>Support</small></div>
            <ul>
              <li>
                <a href="#">
                  <svg class="icon"><use xlink:href="#mobile-call"></use></svg>
                  <span>Give us a call</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <svg class="icon"><use xlink:href="#request-call"></use></svg>
                  <span>Request a call</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <svg class="icon"><use xlink:href="#chat"></use></svg>
                  <span>Chat to us</span>
                </a>
              </li>
            </ul>

            <div class="modal-appbar__menu-title"><small>Resources</small></div>
            <ul>
              <li>
                <a href="#">
                  <svg class="icon"><use xlink:href="#video-screen"></use></svg>
                  <span>Tips and how-tos</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <svg class="icon"><use xlink:href="#q-a"></use></svg>
                  <span>FAQs</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <svg class="icon"><use xlink:href="#blog"></use></svg>
                  <span>Blog</span>
                </a>
              </li>
            </ul>

          </nav>
        </div>

      </div>
    </div>
    @if (false) {
      <div class="layout__sidecol">
        <nav class="central-nav">
          <ul class="central-nav__list list-unstyled">
            <li class="is-active">
              <a  href="javascript:void(0);">
                <svg class="icon">
                  <use xlink:href="#policies"></use>
                </svg>
                <span>Dashboard</span>
              </a>
            </li>
            <li>
              @if (person?.broker_id > 0 || person?.console_access) {
                <a  href="javascript:void(0);"  (click)="changeMode('Policies')">
                  <svg class="icon">
                    <use xlink:href="#policies"></use>
                  </svg>
                  <span>Policies</span>
                </a>
              }
            </li>
            @if (person?.broker_id > 0 || person?.console_access) {
              <li>
                <a href="javascript:void(0);" (click)="changeMode('Quotes')">
                  <svg class="icon">
                    <use xlink:href="#quotes"></use>
                  </svg>
                  <span>Quotes</span>
                </a>
              </li>
            }
            @if (underwriting) {
              <li [class]="mode === 'Underwriting' ? 'is-active' : '' ">
                <a href="javascript:void(0);" (click)="changeMode('Underwriting')">
                  <svg class="icon">
                    <use xlink:href="#quotes"></use>
                  </svg>
                  <span>Underwriting</span>
                </a>
              </li>
            }
            @if (claims) {
              <li [class]="mode === 'Claims' ? 'is-active' : '' ">
                <a href="javascript:void(0);" (click)="changeMode('Claims')">
                  <svg class="icon">
                    <use xlink:href="#quotes"></use>
                  </svg>
                  <span>Claims</span>
                </a>
              </li>
            }
            <!-- <li [routerLinkActive]="'is-active'" >
            <a href="javascript:void(0);" [routerLink]="['/' + RouterLinks.BrokerResources]">
              <svg class="icon">
                <use xlink:href="#quotes"></use>
              </svg>
              <span>Resources</span>
            </a>
          </li> -->
        </ul>
      </nav>
    </div>
  }

  <div class="layout__bodycol">

    <!-- this 'back nav' is only shown when a manager is viewing a client's data -->
    <div class="central-filter central-filter--dash" id="demoBackNav" style="display:none">
      <div class="central-header__filter">
        <a href="everything.b2b-dash-team.html" class="central-header__filter-back">
          <svg class="icon">
            <use xlink:href="#left-small"></use>
          </svg>
        </a>
        <h4>Cora Forbes</h4>
      </div>
    </div>

    <div class="central-filter central-filter--dash">
      @if (isDeeper) {
        <div class="central-header__filter">
          <a href="javascript:;" (click)="isDeeper = false" class="central-header__filter-back">
            <svg class="icon">
              <use xlink:href="#left-small"></use>
            </svg>
          </a>
          <h4>{{isDeeperLabel}}</h4>
          <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam." data-original-title="" title=""><svg class="icon icon--sm">
            <use xlink:href="#help-Icon"></use>
          </svg>
        </a>
        <div class="dropdown dropdown--central dropdown--persist" id="metric-dropdown">
          <a href="#" class="dropdown-toggle dropdown-toggle--grey" data-toggle="dropdown" id="metric-dropdown-toggle">
          </a>
          <div class="dropdown-menu dropdown-menu-left filter-list__scrollable">
            <div class="filter-list__content">
              <ul class="filter-list filter-list--central list-unstyled" id="metric-filter-list">
                <li>
                  <label class="custom-input custom-input--radio">
                    <input type="radio" checked="" value="loss-ratio" name="metric-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Loss Ratio</span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--radio">
                    <input type="radio" value="metric-name" name="metric-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">[Metric]</span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--radio">
                    <input type="radio" value="metric-name-2" name="metric-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">[Metric]</span>
                  </label>
                </li>
              </ul>
            </div>
            <div class="filter-list__button">
              <button id="metric-filter-apply" class="button button--primary button--block">Apply</button>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!isDeeper) {
      <div  class="central-filter__tabnav">
        <nav class="tab-nav tab-nav--dash">
          <div class="tab-nav__inner">
            <ul class="list-unstyled" id="dashboard-nav">
              <li style="display:none" id="demoTeamNavItem"><a href="everything.b2b-dash-team.html" data-category="team">Team</a></li>
              <!-- <li [ngClass]="{'is-active': selectedView === 'Overview'}"><a href="javascript:;" data-category="overview" (click)="setView('Overview')">Overview</a></li> -->
              <li [ngClass]="{'is-active': selectedView === 'Policies'}"><a href="javascript:;" data-category="policies" (click)="setView('Policies')">Policies</a></li>
              <li [ngClass]="{'is-active': selectedView === 'Quotes'}"><a href="javascript:;" data-category="quotes" (click)="setView('Quotes')">Quotes</a></li>
              <li [ngClass]="{'is-active': selectedView === 'Renewals'}"><a href="javascript:;" data-category="renewals" (click)="setView('Renewals')">Renewals</a></li>
              <li [ngClass]="{'is-active': selectedView === 'Claims'}"><a href="javascript:;" data-category="claims" (click)="setView('Claims')">Claims</a></li>
              <li [ngClass]="{'is-active': selectedView === 'Underwriting'}"><a href="javascript:;" data-category="underwriting" (click)="setView('Underwriting')">Underwriting</a>
            </li>
          </ul>
        </div>
      </nav>
      <!-- .tab-nav -->
    </div>
  }
  <div class="central-header__actions">

    <div class="dropdown dropdown--central dropdown--persist d-none d-md-flex" id="daterange-dropdown">

      <div class="central-header__actions-date d-none d-md-flex" data-toggle="dropdown" id="daterange-dropdown-trigger">

        <div id="daterange-from">
          All Time
        </div>

        <small>-</small>

        <div id="daterange-to">
          To Date
        </div>

        <svg class="icon">
          <use xlink:href="#calendar"></use>
        </svg>

      </div>
      <div class="dropdown-menu dropdown-menu-right dropdown-menu--daterange filter-list__scrollable">

        <div class="filter-daterange" id="daterange-calendars">

          <div class="ui-datepicker__daterange is-active" id="daterange-calendar-from">

            <div class="ui-datepicker__picker-header" id="filter-daterange-inline-from">
              <div class="ui-datepicker__wrap">
                <div class="form-control__wrap has-icon">
                  <input type="hidden" readonly id="filter-daterange-inline-from-input" />
                </div>
              </div>
            </div>

          </div>

          <div class="ui-datepicker__daterange" id="daterange-calendar-to">

            <div class="ui-datepicker__picker-header" id="filter-daterange-inline-to">
              <div class="ui-datepicker__wrap">
                <div class="form-control__wrap has-icon">
                  <input type="hidden" readonly id="filter-daterange-inline-to-input" />
                </div>
              </div>
            </div>

          </div>

        </div>
        <div class="filter-list__right">
          <div class="filter-list__content">
            <ul class="filter-list filter-list--central list-unstyled" id="date-range-filter-list">
              <li>
                <label class="custom-input custom-input--radio">
                  <input type="radio" value="custom" (click)="setPeriod('custom')"  data-title="Custom" name="date-range[]">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Custom</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--radio">
                  <input type="radio" value="week" (click)="setPeriod('week')"  data-title="Past 7 Days" name="date-range[]">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Past 7 Days</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--radio">
                  <input type="radio" value="month" (click)="setPeriod('past-month')" data-title="Past Month" name="date-range[]">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Past Month</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--radio">
                  <input type="radio" value="year" (click)="setPeriod('past-year')"  data-title="Past Year" name="date-range[]">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Past Year</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--radio">
                  <input type="radio" checked="true" (click)="setPeriod('all-time')" value="all-time" data-title="All Time" name="date-range[]">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">All Time</span>
                </label>
              </li>

            </ul>



          </div>
          <div class="filter-list__button">
            <a href="javascript:;" id="date-range-cancel" class="button button--secondary button--block dropdown-close">Cancel</a>
            <a href="javascript:;" id="date-range-apply" disabled="" class="button button--primary button--block dropdown-close">Apply</a>
          </div>
        </div>
      </div>
    </div>

    <a href="#filters" class="central-header__actions-filters is-dash d-none d-md-flex" id="filters-trigger">
      <div>Filters</div>
      <span>{{filterCount}}</span>
    </a>

    <div class="central-filter__filters d-md-none">
      <a href="#modal-traymenu-filters" data-toggle="modal">
        <svg class="icon">
          <use xlink:href="#filter"></use>
        </svg>
      </a>
    </div>

  </div>
</div>
<div class="layout__bodycol-inner">

  @if (!isDeeper) {
    <div class="b2b-dash">
      @if (selectedView === 'Policies') {
        @for (index of indexes; track index) {
          <div class="b2b-dash__row">
            @if (index === 1) {
              @for (item of getIndexChidren(index); track item) {
                <div class="b2b-dash__cell">
                  <!-- if not linked, use div -->
                  <!-- <ng-container *ngFor="let item of getPolicyIndex(index, idx); let i=index;"> -->
                  <a href="javascript:" (click)="deeperGraph(item,index,'policies')"
                    class="b2b-card-graph {{item?.icon_path === 'down_arrow.svg'? 'b2b-card-graph--negative':''}}">
                    <div class="b2b-card-graph__header">
                      <strong class="font-semibold"><small>{{item?.label}}</small></strong>
                      <svg class="icon">
                        <use xlink:href="#chevron-right-small"></use>
                      </svg>
                    </div>
                    <div class="b2b-card-graph__value">
                      <h4>{{item?.value}}</h4>
                    </div>
                    <div class="b2b-card-graph__label">
                      <svg class="icon icon--sm">
                        <use xlink:href="#down-small"></use>
                      </svg>
                      <strong class="font-semibold"><small>{{item?.global_avg}} </small></strong>
                    </div>
                    <div class="b2b-card-graph__indi">
                      @if (item?.img_path === 'down_graph.svg') {
                        <img src="assets/img/card-graph-negative.svg" alt="">
                      }
                      @if (item?.img_path === 'up_graph.svg') {
                        <img src="assets/img/card-graph-positive.svg" alt="">
                      }
                    </div>
                  </a>
                <!-- </ng-container> -->
              </div>
            }
          }
          @if (index === 2) {
            @for (idx of getIndexChidren(index); track idx; let i = $index) {
              <div class="b2b-dash__cell b2b-dash__cell--half">
                <div class="b2b-card-list">
                  <!-- <ng-container *ngFor="let item of getPolicyIndex(index, idx); let x=index;"> -->
                  <div  class="b2b-card-list__header">
                    <h6  class="font-semibold">{{idx?.label}}</h6>
                    <div class="h3">{{idx?.value}}</div>
                  </div>
                <!-- </ng-container> -->
                <div class="b2b-card-list__list">
                  @for (item of getPolicyIndex(index, idx?.index_2); track item; let y = $index) {
                    @if (y > 0 && y < idx?.parameters?.top) {
                      <a href="javascript:;" class="b2b-card-list__item">
                        <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                          <svg class="icon icon--sm">
                            <use xlink:href="#tag-outline"></use>
                          </svg>
                        </div>
                        <div class="b2b-card-list__title">{{item?.label}}<strong></strong></div>
                        <div class="b2b-card-list__value">{{item?.value}}</div>
                      </a>
                    }
                  }
                </div>
                @if (getPolicyIndex(index, idx?.index_2)?.length > 6) {
                  <div class="b2b-card-list__more">
                    <a href="javascript:;" (click)="deeperGraph(getPolicyIndex(index, idx?.index_2)[0],index, 'policies')" class="font-semibold"><small>View
                    All</small></a>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  }
  @if (selectedView === 'Quotes') {
    @for (index of indexes; track index) {
      <div class="b2b-dash__row">
        @if (index === 1) {
          @for (item of getIndexChidren(index); track item) {
            <div class="b2b-dash__cell">
              <a href="javascript:;" (click)="deeperGraph(item, index, 'quotes')" class="b2b-card-color {{item?.css === 'Green' ? '': 'b2b-card-color--negative'}}">
                <div class="b2b-card-color__header">
                  <strong class="font-semibold"><small>{{item?.label}}</small></strong>
                  <svg class="icon">
                    <use xlink:href="#chevron-right-small"></use>
                  </svg>
                </div>
                <div class="b2b-card-color__value">
                  <h4>{{item?.value}}</h4>
                </div>
                <div class="b2b-card-color__label">
                  <svg class="icon icon--sm">
                    <use xlink:href="#down-small"></use>
                  </svg>
                  <strong class="font-semibold"><small>{{item?.global_avg}}</small></strong>
                </div>
              </a>
            </div>
          }
        }
        @if (index === 2) {
          @for (idx of getIndexChidren(index); track idx; let i = $index) {
            <div class="b2b-dash__cell b2b-dash__cell--half">
              <div class="b2b-card-list">
                <!-- <ng-container *ngFor="let item of getPolicyIndex(index, idx); let x=index;"> -->
                <div  class="b2b-card-list__header">
                  <h6  class="font-semibold">{{idx?.label}}</h6>
                  <div class="h3">{{idx?.value}}</div>
                </div>
              <!-- </ng-container> -->
              <div class="b2b-card-list__list">
                @for (item of getPolicyIndex(index, idx?.index_2); track item; let y = $index) {
                  @if (y > 0 && y < idx?.parameters?.top) {
                    <a href="javascript:;" class="b2b-card-list__item">
                      <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                        <svg class="icon icon--sm">
                          <use xlink:href="#tag-outline"></use>
                        </svg>
                      </div>
                      <div class="b2b-card-list__title">{{item?.label}}<strong></strong></div>
                      <div class="b2b-card-list__value">{{item?.value}}</div>
                    </a>
                  }
                }
              </div>
              @if (getPolicyIndex(index, idx?.index_2)?.length > 6) {
                <div class="b2b-card-list__more">
                  <a href="javascript:;" (click)="deeperGraph(getPolicyIndex(index, idx?.index_2)[0],index, 'quotes')" class="font-semibold"><small>View
                  All</small></a>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  }
  <div class="b2b-dash__row">
    @for (item of getQuoteIndex(0); track item) {
      <div class="b2b-dash__cell">
        <!-- if linked, use 'a' tag -->
      </div>
    }
  </div>
  @if (false) {
    <div class="b2b-dash__row">
      <div class="b2b-dash__cell b2b-dash__cell--half">
        <div class="b2b-card-list">
          <div class="b2b-card-list__header">
            <h6 class="font-semibold">{{getQuoteIndex(10)[0]?.label}}</h6>
            <!-- <div class="h3">2 500</div> -->
          </div>
          <div class="b2b-card-list__list">
            @for (item of getQuoteIndex(10); track item; let i = $index) {
              @if ( i < 5) {
                <a href="#" class="b2b-card-list__item">
                  <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                    <svg class="icon icon--sm">
                      <use xlink:href="#tag-outline"></use>
                    </svg>
                  </div>
                  <div class="b2b-card-list__title">{{item?.name}} <strong></strong></div>
                  <div class="b2b-card-list__value">{{item?.quote_count}}</div>
                </a>
              }
            }
          </div>
          <div class="b2b-card-list__more">
            <a href="javascript:;" (click)="deeperGraph(getQuoteIndex(10))" class="font-semibold"><small>View All</small></a>
          </div>
        </div>
      </div>
      <div class="b2b-dash__cell b2b-dash__cell--half">
        <div class="b2b-card-fact b2b-card-fact--lg">
          <div class="b2b-card-fact__inner">
            <img src="/assets/img/thinking-guy.svg" alt="" class="img-responsive">
            <h6 class="font-semibold">Fast Fact</h6>
            <p>The word ‘insurance’ is derived from the French word ‘ensurer’ and originally meant an ‘engagement to
              marry’. Over time the word evolved to become ‘assurance’ and later ‘insurance’ with its modern meaning.
            </p>
          </div>
        </div>
      </div>
    </div>
  }
}
@if (selectedView === 'Renewals') {
  @for (index of indexes; track index) {
    <div class="b2b-dash__row">
      @if (index === 1) {
        @for (item of getIndexChidren(index); track item) {
          <div class="b2b-dash__cell">
            <a href="javascript:;" (click)="deeperGraph(item)" class="b2b-card-color {{item?.css === 'Green' ? '': 'b2b-card-color--negative'}}">
              <div class="b2b-card-color__header">
                <strong class="font-semibold"><small>{{item?.label}}</small></strong>
                <svg class="icon">
                  <use xlink:href="#chevron-right-small"></use>
                </svg>
              </div>
              <div class="b2b-card-color__value">
                <h4>{{item?.value}}</h4>
              </div>
              <div class="b2b-card-color__label">
                <svg class="icon icon--sm">
                  <use xlink:href="#down-small"></use>
                </svg>
                <strong class="font-semibold"><small>{{item?.global_avg}}</small></strong>
              </div>
            </a>
          </div>
        }
      }
      @if (index === 2) {
        @for (idx of getIndexChidren(index); track idx; let i = $index) {
          <div class="b2b-dash__cell b2b-dash__cell--half">
            <div class="b2b-card-list">
              <!-- <ng-container *ngFor="let item of getPolicyIndex(index, idx); let x=index;"> -->
              <div  class="b2b-card-list__header">
                <h6  class="font-semibold">{{idx?.label}}</h6>
                <div class="h3">{{idx?.value}}</div>
              </div>
            <!-- </ng-container> -->
            <div class="b2b-card-list__list">
              @for (item of getPolicyIndex(index, idx?.index_2); track item; let y = $index) {
                @if (y > 0 && y < idx?.parameters?.top) {
                  <a href="javascript:;" class="b2b-card-list__item">
                    <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                      <svg class="icon icon--sm">
                        <use xlink:href="#tag-outline"></use>
                      </svg>
                    </div>
                    <div class="b2b-card-list__title">{{item?.label}}<strong></strong></div>
                    <div class="b2b-card-list__value">{{item?.value}}</div>
                  </a>
                }
              }
            </div>
            @if (getPolicyIndex(index, idx?.index_2)?.length > 6) {
              <div class="b2b-card-list__more">
                <a href="javascript:;" (click)="deeperGraph(getPolicyIndex(index, idx?.index_2)[0],index, idx, 'policies')" class="font-semibold"><small>View
                All</small></a>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
}
<div class="b2b-dash__row">
  @for (item of getQuoteIndex(0); track item) {
    <div class="b2b-dash__cell">
      <!-- if linked, use 'a' tag -->
    </div>
  }
</div>
@if (false) {
  <div class="b2b-dash__row">
    <div class="b2b-dash__cell b2b-dash__cell--half">
      <div class="b2b-card-list">
        <div class="b2b-card-list__header">
          <h6 class="font-semibold">{{getQuoteIndex(10)[0]?.label}}</h6>
          <!-- <div class="h3">2 500</div> -->
        </div>
        <div class="b2b-card-list__list">
          @for (item of getQuoteIndex(10); track item; let i = $index) {
            @if ( i < 5) {
              <a href="#" class="b2b-card-list__item">
                <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                  <svg class="icon icon--sm">
                    <use xlink:href="#tag-outline"></use>
                  </svg>
                </div>
                <div class="b2b-card-list__title">{{item?.name}} <strong></strong></div>
                <div class="b2b-card-list__value">{{item?.quote_count}}</div>
              </a>
            }
          }
        </div>
        <div class="b2b-card-list__more">
          <a href="javascript:;" (click)="deeperGraph(getQuoteIndex(10))" class="font-semibold"><small>View All</small></a>
        </div>
      </div>
    </div>
    <div class="b2b-dash__cell b2b-dash__cell--half">
      <div class="b2b-card-fact b2b-card-fact--lg">
        <div class="b2b-card-fact__inner">
          <img src="/assets/img/thinking-guy.svg" alt="" class="img-responsive">
          <h6 class="font-semibold">Fast Fact</h6>
          <p>The word ‘insurance’ is derived from the French word ‘ensurer’ and originally meant an ‘engagement to
            marry’. Over time the word evolved to become ‘assurance’ and later ‘insurance’ with its modern meaning.
          </p>
        </div>
      </div>
    </div>
  </div>
}
}
@if (selectedView === 'Claims') {
  @for (index of indexes; track index) {
    <div class="b2b-dash__row">
      @if (index === 1) {
        @for (item of getIndexChidren(index); track item) {
          <div class="b2b-dash__cell">
            <a href="javascript:;" (click)="deeperGraph(item)" class="b2b-card-color {{item?.css === 'Green' ? '': 'b2b-card-color--negative'}}">
              <div class="b2b-card-color__header">
                <strong class="font-semibold"><small>{{item?.label}}</small></strong>
                <svg class="icon">
                  <use xlink:href="#chevron-right-small"></use>
                </svg>
              </div>
              <div class="b2b-card-color__value">
                <h4>{{item?.value}}</h4>
              </div>
              <div class="b2b-card-color__label">
                <svg class="icon icon--sm">
                  <use xlink:href="#down-small"></use>
                </svg>
                <strong class="font-semibold"><small>{{item?.global_avg}}</small></strong>
              </div>
            </a>
          </div>
        }
      }
      @if (index === 2) {
        @for (idx of getIndexChidren(index); track idx; let i = $index) {
          <div class="b2b-dash__cell b2b-dash__cell--half">
            <div class="b2b-card-list">
              <!-- <ng-container *ngFor="let item of getPolicyIndex(index, idx); let x=index;"> -->
              <div  class="b2b-card-list__header">
                <h6  class="font-semibold">{{idx?.label}}</h6>
                <div class="h3">{{idx?.value}}</div>
              </div>
            <!-- </ng-container> -->
            <div class="b2b-card-list__list">
              @for (item of getPolicyIndex(index, idx?.index_2); track item; let y = $index) {
                @if (y > 0 && y < idx?.parameters?.top) {
                  <a href="javascript:;" class="b2b-card-list__item">
                    <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                      <svg class="icon icon--sm">
                        <use xlink:href="#tag-outline"></use>
                      </svg>
                    </div>
                    <div class="b2b-card-list__title">{{item?.label}}<strong></strong></div>
                    <div class="b2b-card-list__value">{{item?.value}}</div>
                  </a>
                }
              }
            </div>
            @if (getPolicyIndex(index, idx?.index_2)?.length > 6) {
              <div class="b2b-card-list__more">
                <a href="javascript:;" (click)="deeperGraph(getPolicyIndex(index, idx?.index_2)[0],index, idx, 'policies')" class="font-semibold"><small>View
                All</small></a>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
}
<div class="b2b-dash__row">
  @for (item of getQuoteIndex(0); track item) {
    <div class="b2b-dash__cell">
      <!-- if linked, use 'a' tag -->
    </div>
  }
</div>
@if (false) {
  <div class="b2b-dash__row">
    <div class="b2b-dash__cell b2b-dash__cell--half">
      <div class="b2b-card-list">
        <div class="b2b-card-list__header">
          <h6 class="font-semibold">{{getQuoteIndex(10)[0]?.label}}</h6>
          <!-- <div class="h3">2 500</div> -->
        </div>
        <div class="b2b-card-list__list">
          @for (item of getQuoteIndex(10); track item; let i = $index) {
            @if ( i < 5) {
              <a href="#" class="b2b-card-list__item">
                <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                  <svg class="icon icon--sm">
                    <use xlink:href="#tag-outline"></use>
                  </svg>
                </div>
                <div class="b2b-card-list__title">{{item?.name}} <strong></strong></div>
                <div class="b2b-card-list__value">{{item?.quote_count}}</div>
              </a>
            }
          }
        </div>
        <div class="b2b-card-list__more">
          <a href="javascript:;" (click)="deeperGraph(getQuoteIndex(10))" class="font-semibold"><small>View All</small></a>
        </div>
      </div>
    </div>
    <div class="b2b-dash__cell b2b-dash__cell--half">
      <div class="b2b-card-fact b2b-card-fact--lg">
        <div class="b2b-card-fact__inner">
          <img src="/assets/img/thinking-guy.svg" alt="" class="img-responsive">
          <h6 class="font-semibold">Fast Fact</h6>
          <p>The word ‘insurance’ is derived from the French word ‘ensurer’ and originally meant an ‘engagement to
            marry’. Over time the word evolved to become ‘assurance’ and later ‘insurance’ with its modern meaning.
          </p>
        </div>
      </div>
    </div>
  </div>
}
}
@if (selectedView === 'Underwriting') {
  @for (index of indexes; track index) {
    <div class="b2b-dash__row">
      @if (index === 1) {
        @for (item of getIndexChidren(index); track item) {
          <div class="b2b-dash__cell">
            <a href="javascript:;" (click)="deeperGraph(item, index, 'quotes')" class="b2b-card-color {{item?.css === 'Green' ? '': 'b2b-card-color--negative'}}">
              <div class="b2b-card-color__header">
                <strong class="font-semibold"><small>{{item?.label}}</small></strong>
                <svg class="icon">
                  <use xlink:href="#chevron-right-small"></use>
                </svg>
              </div>
              <div class="b2b-card-color__value">
                <h4>{{item?.value}}</h4>
              </div>
              <div class="b2b-card-color__label">
                <svg class="icon icon--sm">
                  <use xlink:href="#down-small"></use>
                </svg>
                <strong class="font-semibold"><small>{{item?.global_avg}}</small></strong>
              </div>
            </a>
          </div>
        }
      }
      @if (index === 2) {
        @for (idx of getIndexChidren(index); track idx; let i = $index) {
          <div class="b2b-dash__cell b2b-dash__cell--half">
            <div class="b2b-card-list">
              <!-- <ng-container *ngFor="let item of getPolicyIndex(index, idx); let x=index;"> -->
              <div  class="b2b-card-list__header">
                <h6  class="font-semibold">{{idx?.label}}</h6>
                <div class="h3">{{idx?.value}}</div>
              </div>
            <!-- </ng-container> -->
            <div class="b2b-card-list__list">
              @for (item of getPolicyIndex(index, idx?.index_2); track item; let y = $index) {
                @if (y > 0 && y < idx?.parameters?.top) {
                  <a href="javascript:;" class="b2b-card-list__item">
                    <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                      <svg class="icon icon--sm">
                        <use xlink:href="#tag-outline"></use>
                      </svg>
                    </div>
                    <div class="b2b-card-list__title">{{item?.label}}<strong></strong></div>
                    <div class="b2b-card-list__value">{{item?.value}}</div>
                  </a>
                }
              }
            </div>
            @if (getPolicyIndex(index, idx?.index_2)?.length > 6) {
              <div class="b2b-card-list__more">
                <a href="javascript:;" (click)="deeperGraph(getPolicyIndex(index, idx?.index_2)[0],index, 'quotes')" class="font-semibold"><small>View
                All</small></a>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
}
<div class="b2b-dash__row">
  @for (item of getQuoteIndex(0); track item) {
    <div class="b2b-dash__cell">
      <!-- if linked, use 'a' tag -->
    </div>
  }
</div>
@if (false) {
  <div class="b2b-dash__row">
    <div class="b2b-dash__cell b2b-dash__cell--half">
      <div class="b2b-card-list">
        <div class="b2b-card-list__header">
          <h6 class="font-semibold">{{getQuoteIndex(10)[0]?.label}}</h6>
          <!-- <div class="h3">2 500</div> -->
        </div>
        <div class="b2b-card-list__list">
          @for (item of getQuoteIndex(10); track item; let i = $index) {
            @if ( i < 5) {
              <a href="#" class="b2b-card-list__item">
                <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                  <svg class="icon icon--sm">
                    <use xlink:href="#tag-outline"></use>
                  </svg>
                </div>
                <div class="b2b-card-list__title">{{item?.name}} <strong></strong></div>
                <div class="b2b-card-list__value">{{item?.quote_count}}</div>
              </a>
            }
          }
        </div>
        <div class="b2b-card-list__more">
          <a href="javascript:;" (click)="deeperGraph(getQuoteIndex(10))" class="font-semibold"><small>View All</small></a>
        </div>
      </div>
    </div>
    <div class="b2b-dash__cell b2b-dash__cell--half">
      <div class="b2b-card-fact b2b-card-fact--lg">
        <div class="b2b-card-fact__inner">
          <img src="/assets/img/thinking-guy.svg" alt="" class="img-responsive">
          <h6 class="font-semibold">Fast Fact</h6>
          <p>The word ‘insurance’ is derived from the French word ‘ensurer’ and originally meant an ‘engagement to
            marry’. Over time the word evolved to become ‘assurance’ and later ‘insurance’ with its modern meaning.
          </p>
        </div>
      </div>
    </div>
  </div>
}
}
@if (isEmpty) {
  <div class="b2b-dash">
    <div class="b2b-dash__row mb-30">
      <div class="b2b-dash__cell b2b-dash__cell--full">
        <div class="empty-state">
          <div class="b2b-dash__row">
            <!-- <div class="b2b-dash__cell b2b-dash__cell--half"> -->
            <div class="b2b-card-fact b2b-card-fact--lg">
              <div class="b2b-card-fact__inner">
                <img src="/assets/img/thinking-guy.svg" alt="" class="img-responsive">
                <h6 class="font-semibold">Fast Fact</h6>
                <p>The word ‘insurance’ is derived from the French word ‘ensurer’ and originally meant an ‘engagement to
                  marry’. Over time the word evolved to become ‘assurance’ and later ‘insurance’ with its modern meaning.
                </p>
              </div>
            </div>
          <!-- </div> -->
        </div>
        <!-- <img src="/assets/0/img/home/unsure.svg" alt="" class="img-fluid mb-30">
        <h3 class="font-normal">No results available</h3>
        <p class="mt-20">Try adjusting or <a href="#" id="filters-reset-link"><strong>clear all</strong></a> filters.</p> -->
      </div>
    </div>
  </div>
</div>
}
</div>
}


@if (isDeeper) {
  <div class="b2b-dash">
    <div class="b2b-b2b-dash__row mb-30">
      @if (graphType === 'list') {
        <div class="b2b-card-list">
          <!-- <div class="b2b-card-list__header">
          <h6 class="font-semibold">{{selectedtItem[0]?.label}}</h6>
          <div class="h3">2 500</div>
        </div> -->
        <div class="b2b-card-list__list">
          @for (item of selectedtItem; track item; let i = $index) {
            <a href="#" class="b2b-card-list__item">
              <div class="b2b-card-list__icon b2b-card-list__icon--reason">
                <svg class="icon icon--sm">
                  <use xlink:href="#tag-outline"></use>
                </svg>
              </div>
              <div class="b2b-card-list__title">{{item?.label}}<strong></strong></div>
              <div class="b2b-card-list__value">{{item?.value}}</div>
            </a>
          }
        </div>
      </div>
    }
    <div class="b2b-dash__cell b2b-dash__cell--full">
      <!-- line chart -->
      @if (graphType === 'line') {
        <div class="b2b-graph" id="chartWrap">
          <header class="b2b-graph__header">
            <h4>{{selectedtItem[0]?.description}}</h4>
            <!-- <ul class="custom-labeltoggle custom-labeltoggle--central" id="lineChartToggler">
            <li [ngClass]="{'is-active': activeChartToggle === 'value'}"  data-value="value" (click)="toggleDashChart('value')">Value (R)</li>
            <li [ngClass]="{'is-active': activeChartToggle === 'number'}" data-value="number" (click)="toggleDashChart('number')">Number</li>
          </ul> -->
        </header>
        <div class="b2b-graph__graph">
          <div style="height:220px; width:100%;">
            <canvas id="lineChart"></canvas>
          </div>
          <ul class="b2b-graph__keys" id="lineChartLegend"></ul>
        </div>
      </div>
    }
  </div>
</div>
</div>
}
</div>
</div>
</div>
</div>
</main>

<app-disclaimer></app-disclaimer>
<div class="modal fade fade-up modal--fullscreen" id="app-bar-more" tabindex="-1" role="dialog" aria-labelledby="app-bar-more" aria-modal="true" >
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-appbar">
      <nav class="modal-appbar__menu">

        <div class="modal-appbar__menu-title"><small>Cover</small></div>
        <ul>
          <li>
            <a href="javascritp:;">
              <svg class="icon"><use xlink:href="#memberships"></use></svg>
              <span>Underwriting</span>
            </a>
          </li>
        </ul>

        <!-- <div class="modal-appbar__menu-title"><small>Policies</small></div>
        <ul>
          <li>
            <a href="#">
              <svg class="icon"><use xlink:href="#document"></use></svg>
              <span>Documents</span>
            </a>
          </li>
          <li>
            <a href="#">
              <svg class="icon"><use xlink:href="#inventory"></use></svg>
              <span>Insured items</span>
            </a>
          </li>
          <li>
            <a href="#">
              <svg class="icon"><use xlink:href="#policy-benefits"></use></svg>
              <span>Benefits</span>
            </a>
          </li>
        </ul> -->

        <div class="modal-appbar__menu-title"><small>Support</small></div>
        <ul>
          <li>
            <a href="#">
              <svg class="icon"><use xlink:href="#mobile-call"></use></svg>
              <span>Give us a call</span>
            </a>
          </li>
          <li>
            <a href="#">
              <svg class="icon"><use xlink:href="#request-call"></use></svg>
              <span>Request a call</span>
            </a>
          </li>
          <li>
            <a href="#">
              <svg class="icon"><use xlink:href="#chat"></use></svg>
              <span>Chat to us</span>
            </a>
          </li>
        </ul>

        <div class="modal-appbar__menu-title"><small>Resources</small></div>
        <ul>
          <li>
            <a href="#">
              <svg class="icon"><use xlink:href="#video-screen"></use></svg>
              <span>Tips and how-tos</span>
            </a>
          </li>
          <li>
            <a href="#">
              <svg class="icon"><use xlink:href="#q-a"></use></svg>
              <span>FAQs</span>
            </a>
          </li>
          <li>
            <a href="#">
              <svg class="icon"><use xlink:href="#blog"></use></svg>
              <span>Blog</span>
            </a>
          </li>
        </ul>

      </nav>
      <!-- <div class="modal-appbar__sos">
      <div class="modal-appbar__sos-inner">
        <a href="javascript:;" (click)="startSOSFlow()" class="button button--block button--lg button--primary">
          <svg class="icon">
            <use xlink:href="#navigation-sos"></use>
          </svg>
          Emergency Assistance
        </a>
      </div>
    </div> -->
  </div>
</div>
</div>
<div id="filters" class="filters">
  <div class="filters__inner">
    <div class="filters__header">
      <h5>Filters</h5>
      <a href="#" class="filters__header-close" data-close="filter">
        <svg class="icon">
          <use xlink:href="#close-medium"></use>
        </svg>
      </a>
    </div>
    <div class="filters__body">

      <div class="filter-accordion">
        <!-- <div class="filter-accordion__item">
        <div class="filter-accordion__header">
          <label class="custom-input custom-input--checkbox">
            <input type="checkbox">
            <span class="custom-input__indi"></span>
          </label>
          <a href="#filter-item-1" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
            <div class="filter-accordion__title-text">Filter standard</div>
            <span class="filter-accordion__title-indi">
              <svg class="icon">
                <use xlink:href="#minus"></use>
              </svg>
              <svg class="icon">
                <use xlink:href="#plus"></use>
              </svg>
            </span>
          </a>
        </div>
        <div id="filter-item-1" class="filter-accordion__body collapse">
          <div class="filter-accordion__content">
            <div class="filter-accordion__search">
              <div class="form-group">
                <div class="input-group">
                  <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                  <div class="input-group-append">
                    <span class="input-group-icon">
                      <svg class="icon">
                        <use xlink:href="#search"></use>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <ul class="filter-accordion__list">
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">A Label</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">B Label</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">C Label</span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div> -->
      @for (filter of filters; track filter; let i = $index) {
        <div class="filter-accordion__item">
          <div class="filter-accordion__header">
            <label class="custom-input custom-input--checkbox">
              <input type="checkbox" value="{{filter?.filter_value}}" (click)="setAllFilter(filter)">
              <span class="custom-input__indi"></span>
            </label>
            <a href="#filter-item-{{i}}" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
              <div class="filter-accordion__title-text">{{filter?.filter_header}}</div>
              <span class="filter-accordion__title-indi">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </span>
            </a>
          </div>
          <div id="filter-item-{{i}}" class="filter-accordion__body collapse">
            <div class="filter-accordion__content">
              <div class="filter-accordion__search">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                    <div class="input-group-append">
                      <span class="input-group-icon">
                        <svg class="icon">
                          <use xlink:href="#search"></use>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <ul class="filter-accordion__list">
                @for (item of getFilters(filter); track item) {
                  <li>
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox" class="{{filter?.filter_value}}-filters" value="{{item?.filter_value}}" (click)="setFilter($event,filter,item)" name="{{filter?.filter_value}}-filter[]">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">
                        <div class="custom-input__label-tag">
                          <span class="tag-pill tag-pill--brokerage tag-pill--brokerage-1">{{item?.filter_label.substring(0,1)}}</span>
                        </div>
                        {{item?.filter_label}}
                      </span>
                    </label>
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      }
      <!-- <div class="filter-accordion__item">
      <div class="filter-accordion__header">
        <a href="#filter-item-3" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
          <div class="filter-accordion__title-text">Filter type radios</div>
          <span class="filter-accordion__title-indi">
            <svg class="icon">
              <use xlink:href="#minus"></use>
            </svg>
            <svg class="icon">
              <use xlink:href="#plus"></use>
            </svg>
          </span>
        </a>
      </div>
      <div id="filter-item-3" class="filter-accordion__body collapse">
        <div class="filter-accordion__content">

          <div class="filter-accordion__search">
            <div class="form-group">
              <div class="input-group">
                <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                <div class="input-group-append">
                  <span class="input-group-icon">
                    <svg class="icon">
                      <use xlink:href="#search"></use>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <ul class="filter-accordion__list">
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" name="radio-filter" checked="">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Label</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" name="radio-filter">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Label</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" name="radio-filter">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Label</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="filter-accordion__item">
      <div class="filter-accordion__parent">
        <strong>Filter type parent</strong>
      </div>
      <div class="filter-accordion__item">
        <div class="filter-accordion__header">
          <a href="#filter-item-4a" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
            <div class="filter-accordion__title-text">Classes example</div>
            <span class="filter-accordion__title-indi">
              <svg class="icon">
                <use xlink:href="#minus"></use>
              </svg>
              <svg class="icon">
                <use xlink:href="#plus"></use>
              </svg>
            </span>
          </a>
        </div>
        <div id="filter-item-4a" class="filter-accordion__body collapse">
          <div class="filter-accordion__content">

            <div class="filter-accordion__search">
              <div class="form-group">
                <div class="input-group">
                  <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                  <div class="input-group-append">
                    <span class="input-group-icon">
                      <svg class="icon">
                        <use xlink:href="#search"></use>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <ul class="filter-accordion__list">
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Product</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Product</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Product</span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="filter-accordion__item">
        <div class="filter-accordion__header">
          <label class="custom-input custom-input--checkbox">
            <input type="checkbox">
            <span class="custom-input__indi"></span>
          </label>
          <a href="#filter-item-4b" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
            <div class="filter-accordion__title-text">Filter standard within parent</div>
            <span class="filter-accordion__title-indi">
              <svg class="icon">
                <use xlink:href="#minus"></use>
              </svg>
              <svg class="icon">
                <use xlink:href="#plus"></use>
              </svg>
            </span>
          </a>
        </div>
        <div id="filter-item-4b" class="filter-accordion__body filter-accordion__body--indent collapse">
          <div class="filter-accordion__content">

            <div class="filter-accordion__search">
              <div class="form-group">
                <div class="input-group">
                  <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                  <div class="input-group-append">
                    <span class="input-group-icon">
                      <svg class="icon">
                        <use xlink:href="#search"></use>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <ul class="filter-accordion__list">
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Label</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Label</span>
                </label>
              </li>
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">Label</span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
  </div>


</div>
<div class="filters__tray">
  <a href="javascript:;" id="filters-reset-btn" (click)="resetFilters()" class="button button--block button--secondary">Reset</a>
  <a href="javascript:;" id="filters-apply-btn" (click)="applyFilters()" class="button button--block button--primary">Apply</a>
</div>
</div>
</div>

